<template>
  <div class="member mk-flex-column-start-center">
    <img class="member-img" :src="topBg">
    <div class="list mk-flex-column-start-center">
      <div class="item mk-flex-row-between-center" v-for="(item, index) in currentList" :key="index" @click="toNewsInfo(item.id)">
        <img class="item-img" :src="item.src" >
        <div class="item-text mk-flex-column-between-start">
          <p>{{item.title}}</p>
          <div class="item-text-tips">
            <span>{{item.author}}</span>
            <span>{{item.time}}</span>
          </div>
        </div>
      </div>
      <el-pagination
        class="zd-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[1, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>


export default {
  name: 'iniustrys',
  data () {
    return {
      topBg: require('@/assets/img/iniustrys-bg.png'),
      total: 10,
      newsTotalList: [
        {
          src: require('@/assets/img/qr.png'),
          title: '国家药监局关于宣传贯彻《中华人民共和国疫苗管理法》的通知',
          author: '国药监法〔2019〕32号',
          time: '2019-07-30',
          id: 1
        },
        {
          src: require('@/assets/img/qr.png'),
          title: '填补国内行业教材空白 《临床研究护士指南》新书分享会在沪举行',
          author: '曹子琛',
          time: '2019-11-10',
          id: 2
        }
      //   ,
      //   {
      //     src: require('@/assets/img/qr.png'),
      //     title: '思派荣获中国财经峰会“最具创新力企业”、“行业影响力品牌”双料大奖',
      //     author: '思派集团',
      //     time: '2020-09-16',
      //     id: 3
      //   }
      // ],
      // currentList: [
      //   {
      //     src: require('@/assets/img/qr.png'),
      //     title: '国家药监局关于宣传贯彻《中华人民共和国疫苗管理法》的通知',
      //     author: '国药监法〔2019〕32号',
      //     time: '2019-07-30',
      //     id: 1
      //   },
      //   {
      //     src: require('@/assets/img/qr.png'),
      //     title: '思派荣获中国财经峰会“最具创新力企业”、“行业影响力品牌”双料大奖',
      //     author: '思派集团',
      //     time: '2020-09-14',
      //     id: 2
      //   },
      //   {
      //     src: require('@/assets/img/qr.png'),
      //     title: '思派荣获中国财经峰会“最具创新力企业”、“行业影响力品牌”双料大奖',
      //     author: '思派集团',
      //     time: '2020-09-14',
      //     id: 3
      //   }
      //   , {
      //     src: require('@/assets/img/qr.png'),
      //     title: '思派荣获中国财经峰会“最具创新力企业”、“行业影响力品牌”双料大奖',
      //     author: '思派集团',
      //     time: '2020-09-14',
      //     id: 4
      //   }
      //   , {
      //     src: require('@/assets/img/qr.png'),
      //     title: '思派荣获中国财经峰会“最具创新力企业”、“行业影响力品牌”双料大奖',
      //     author: '思派集团',
      //     time: '2020-09-14',
      //     id: 5
      //   },
      //   {
      //     src: require('@/assets/img/qr.png'),
      //     title: '思派荣获中国财经峰会“最具创新力企业”、“行业影响力品牌”双料大奖',
      //     author: '思派集团',
      //     time: '2020-09-14',
      //     id: 6
      //   }
      ],
      currentPage: 1,
      pageSize: 1
    }
  },
  methods: {
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.currentList = this.selectWherePage()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.currentList = this.selectWherePage()
    },// 数据分发
    selectWherePage (page = this.currentPage, pageSize = this.pageSize, array = this.newsTotalList) {
        let start = Math.round((page - 1) * pageSize)
        let end = Math.round(pageSize * page)
        let length = array.length
        if (length < end) {
            end = length
        }
        return array.slice(start, end)
    },
    toNewsInfo (id) {
      let routeUrl = this.$router.resolve({
        name: 'information',
        query: {
          newsId: id
        }
      })
     window.open(routeUrl.href, '_blank');
    }
  }
}
</script>
<style scoped>
  img {
    vertical-align: bottom;
  }
  .member {
    width: 100%;
    background-color: #F9F9F9;
    padding-bottom: 152px;
  }
  .member-img {
    width: 100%;
    height: 200px;
  }
  .list {
    width: 920px;
    margin-top: 97px;
    background: #ffffff;
    padding-bottom: 20px;
  }
  .item {
    height: 150px;
    text-align: left;
    padding: 10px;
  }
  .item-img {
    width: 200px;
    height: 100%;
    margin-right: 24px;
  }
  .item-text {
    flex: 1;
    height: 100%;
    padding-right: 30px;
  }
  .item-text p {
    font-size: 20px;
    font-weight: 600;
    white-space: pre-wrap;
  }
  .item-text-tips {
    color: #d8d8d8;
    font-size: 14px;
  }
  .item-text-tips span:first-child {
    margin-right: 10px;
  }
  .tips-more {
    width: 100%;
    height: 40px;
  }
  .layout {
    height: 128px;
  }
  p {
    text-align: left;
  }
  .zd-pagination {
    align-self: flex-end;
    margin-top: 20px;
  }
</style>
